<template>
  <div
    class="whatsapp-tutorial-step"
    :class="{ 'whatsapp-tutorial-step--stacked': isStacked }"
    :style="{
      borderColor: getAssets.colors.whatsapp.tutorialCardIcon,
      'background-color': getAssets.colors.whatsapp.tutorialCardStepBackground,
      '--icon-color': getAssets.colors.whatsapp.tutorialCardIcon
    }"
  >
    <div class="whatsapp-tutorial-step__content">
      <v-icon class="whatsapp-tutorial-step__icon" :style="{ color: getAssets.colors.whatsapp.tutorialCardIcon }" size="60">
        {{ step.icon }}
      </v-icon>
      <div class="whatsapp-tutorial-step__text" v-html="step.text"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WhatsappTutorialStep',
  props: {
    step: {
      type: Object,
      required: true,
      validator: value => {
        return value.text && value.icon
      }
    },
    isStacked: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS']),
    getAssets() {
      return this.GET_ASSETS
    }
  }
}
</script>

<style lang="scss" scoped>
.whatsapp-tutorial-step {
  border-radius: 8px;
  border: 2px solid;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex: 1 1 0;
  min-width: 160px;
  max-width: 300px;
  min-height: 140px;
  display: flex;
  flex-direction: column;

  &__content {
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    flex: 1;
    justify-content: center;
  }

  &__icon {
    margin-bottom: 12px;
  }

  &__text {
    margin: 0;
    color: #000000;
    font-size: 20px;
    line-height: 1.4;

    ::v-deep .highlight-content {
      font-weight: bold;
      color: var(--icon-color);
    }

    ::v-deep .observation-content {
      font-size: 14px;
    }
  }

  &--stacked {
    min-height: 180px;

    .whatsapp-tutorial-step__content {
      padding: 24px;
    }

    .whatsapp-tutorial-step__icon {
      font-size: 48px !important;
      margin-bottom: 16px;
    }

    .whatsapp-tutorial-step__text {
      font-size: 20px;
      line-height: 1.5;
    }
  }
}

// Adjust max-width at different breakpoints to allow more flexibility
@media screen and (max-width: 1200px) {
  .whatsapp-tutorial-step {
    max-width: 250px;
  }
}

@media screen and (max-width: 1000px) {
  .whatsapp-tutorial-step {
    max-width: 220px;
    min-height: 130px;
  }
}

@media screen and (max-width: 900px) {
  .whatsapp-tutorial-step {
    max-width: 250px; // Can grow more since arrows are hidden
    min-width: 140px;
  }
}

@media screen and (max-width: 800px) {
  .whatsapp-tutorial-step {
    max-width: 180px;
    min-width: 140px;
    min-height: 120px;
  }
}

@media screen and (max-width: 600px) {
  .whatsapp-tutorial-step {
    &__content {
      padding: 14px;
    }

    &__text {
      font-size: 20px;
    }
  }
}
</style>
